import React from 'react';
import PropTypes from 'prop-types';
import {Image} from "react-bootstrap";
import useImage from "../hooks/useImage";

MyImage.propTypes = {};

interface Props {
    fileName: string;
}

function MyImage(props: Props) {
    const {fileName} = props;
    const {loading, error, image} = useImage(fileName)

    if (loading) return <p>Loading...</p>
    if (error) return <p>Error: {error}</p>
    if (!image) return <p>No image found</p>
    return (
        <Image className={"p-1"} src={image}/>
    );
}

export default MyImage;